import { Text } from '@adc/parallax-component-library';

type LinkProps = {
  onPressLink?: (href: string) => void;
  href?: string;
  target?: string;
  children?: React.ReactElement;
};

export const Link = ({ onPressLink, href, target, children }: LinkProps) => {
  return (
    <Text
      tag="a"
      // @ts-expect-error no `rel` property
      rel="noreferrer"
      href={href}
      target={target}
      type="$bodyBase.default"
      color="$interactive.core.enabled"
      style={{ textDecorationLine: 'none' }}
      onPress={(e) => {
        if (onPressLink && href && !href?.startsWith('https')) {
          e.preventDefault();
          onPressLink(href);
        }
      }}
    >
      {children}
    </Text>
  );
};
